















import { defineComponent, toRefs } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { ProductVariant } from '~/types/commercetools';
import ProductPricing from '~/components/molecules/Product/ProductPricing/ProductPricing.vue';
import { useProductPrice } from '~/composables';

export default defineComponent({
  name: 'ProductSummaryDetails',
  components: {
    ProductPricing,
  },
  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
    isActiveProduct: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: { product: ProductVariant }) {
    const { product } = toRefs(props);

    const { getPriceInformation } = useProductPrice();

    const { productPrice, discountedPrice } = getPriceInformation(product);
    return {
      productPrice,
      discountedPrice,
    };
  },
});
